



























































































import { Vue, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { NavModule, ProfileModule } from "@/store";
import { MediaQuery } from '@/MediaQuery';
import {
  mdbAlert,
  mdbBtn,
  mdbCol,
  mdbContainer,
  mdbInput,
  mdbRow
} from "mdbvue";
import { RouterUtils } from '@/router/RouterUtils'

// Define the props by using Vue's canonical way.
const DailyAllowanceProps = Vue.extend({
  props: {
    personId: String
  },
  mixins: [RouterUtils]
});

@Component({
  components: {
    mdbAlert,
    mdbBtn,
    mdbCol,
    mdbContainer,
    mdbInput,
    mdbRow
  }
})
export default class DailyAllowance extends DailyAllowanceProps {
  navStore: NavModule = getModule(NavModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  MediaQuery = MediaQuery;

  snackbarLimit: number | null = null
  successMsg: string | null = null

  get activeSection() {
      return "form";
  }
  get isButtonDisabled() {
    if (this.snackbarLimit == null || this.snackbarLimit <= 0) {
      return true;
    }
    return false;
  }

  @Watch("$route", { immediate: true, deep: true })
  onRouteChange(newRoute: any, oldRoute: any): void {
    // console.log("deposits route", this.$route, oldVal, newVal);
    if (newRoute.hash !== oldRoute.hash) {
      // something?
    }
  }
  /* *** method elements: mixins, methods *** */
  // methods: {
  //   ...mapGetters("bank", ["getAuthorizedActivePersons"]),
  //   ...mapMutations("nav", ["pushBackbarStack", "resetBackbarStack"]),
  handleNextClick() {
    // add route to stack
    this.navStore.pushBackbarStack(this.$route);
    // TODO FRANK
    // perform the save
    // then () =>
    // add hash to URL
    this.successMsg = "Hooray";
    window.location.hash = "daily-allocation-result";
    // error () =>
    // this.errorMsg = ''
  }

  /* *** lifecycle elements: created, mounted *** */
  created() {}
  mounted() {}
}
